import React from 'react'
import { getAppConfig } from '@/config/config'
import styles from './Link.module.scss'
import Icon from '@/components/Icon/Icon'
import { clsx } from 'clsx'

export default function Link(props: {
  onClick?: (e: React.MouseEvent) => void
  href: string
  target?: string
  children: React.ReactNode
  title?: string
  rel?: string
  className?: string
  tabIndex?: number
  onKeyDown?: (event: React.KeyboardEvent<HTMLAnchorElement>) => void
  arrow?: boolean
}) {
  const cleanedProps = { ...props }
  const config = getAppConfig()
  if (
    cleanedProps.href &&
    cleanedProps.href.includes(`www.n-tv.de${config.basePath}`) &&
    new URL(cleanedProps.href).host.includes('n-tv.de')
  ) {
    cleanedProps.href = new URL(cleanedProps.href).pathname
  }
  delete cleanedProps.arrow

  return (
    <a {...cleanedProps} className={clsx(props.arrow && styles['arrow-icon-link'], props.className)}>
      {cleanedProps.children}
      {props.arrow && <Icon name="arrowRightUp" size={24} className={styles['arrow-icon']} />}
    </a>
  )
}
